module.exports = __webpack_public_path__ + "img/comment_good_icon.b168aef8.png";